module.exports = __webpack_public_path__ + "static/media/024.aa475ff1.jpg";